// extracted by mini-css-extract-plugin
export default {"menuDesktop":"menuDesktop_jlHHl"};